/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUserPrefs = /* GraphQL */ `
  mutation CreateUserPrefs($input: CreateUserPrefsInput!) {
    createUserPrefs(input: $input) {
      username
      inputs {
        numRecordsPerPage
        emailAddresses
        savedSearches {
          name
          filterText
          maskStatus
          modes
        }
      }
      lastSite {
        sitename
        siteRegion
      }
      readersAlarms {
        numRecordsPerPage
        emailAddresses
        savedSearches {
          name
          filterText
          maskStatus
          modes
        }
      }
      readersModes {
        numRecordsPerPage
        emailAddresses
        savedSearches {
          name
          filterText
          maskStatus
          modes
        }
      }
      site
      sites {
        sitename
        siteRegion
      }
    }
  }
`;
export const updateUserPrefs = /* GraphQL */ `
  mutation UpdateUserPrefs($input: UpdateUserPrefsInput!) {
    updateUserPrefs(input: $input) {
      username
      inputs {
        numRecordsPerPage
        emailAddresses
        savedSearches {
          name
          filterText
          maskStatus
          modes
        }
      }
      lastSite {
        sitename
        siteRegion
      }
      readersAlarms {
        numRecordsPerPage
        emailAddresses
        savedSearches {
          name
          filterText
          maskStatus
          modes
        }
      }
      readersModes {
        numRecordsPerPage
        emailAddresses
        savedSearches {
          name
          filterText
          maskStatus
          modes
        }
      }
      site
      sites {
        sitename
        siteRegion
      }
    }
  }
`;
export const deleteUserPrefs = /* GraphQL */ `
  mutation DeleteUserPrefs($input: DeleteUserPrefsInput!) {
    deleteUserPrefs(input: $input) {
      username
      inputs {
        numRecordsPerPage
        emailAddresses
        savedSearches {
          name
          filterText
          maskStatus
          modes
        }
      }
      lastSite {
        sitename
        siteRegion
      }
      readersAlarms {
        numRecordsPerPage
        emailAddresses
        savedSearches {
          name
          filterText
          maskStatus
          modes
        }
      }
      readersModes {
        numRecordsPerPage
        emailAddresses
        savedSearches {
          name
          filterText
          maskStatus
          modes
        }
      }
      site
      sites {
        sitename
        siteRegion
      }
    }
  }
`;
export const createUserAction = /* GraphQL */ `
  mutation CreateUserAction($input: UserActionInput!) {
    createUserAction(input: $input) {
      actionId
      actionName
      timestamp
      username
      parameters
    }
  }
`;
export const updateUserAction = /* GraphQL */ `
  mutation UpdateUserAction($input: UserActionInput!) {
    updateUserAction(input: $input) {
      actionId
      actionName
      timestamp
      username
      parameters
    }
  }
`;
export const setReaderMode = /* GraphQL */ `
  mutation SetReaderMode($input: SetReaderModeInput!) {
    setReaderMode(input: $input) {
      devices {
        deviceName
        status
      }
      message
      requestUUID
      status
    }
  }
`;
export const setInputMask = /* GraphQL */ `
  mutation SetInputMask($input: SetInputMaskInput!) {
    setInputMask(input: $input) {
      devices {
        deviceName
        status
      }
      message
      requestUUID
      status
    }
  }
`;
export const setReaderDoorHeldMask = /* GraphQL */ `
  mutation SetReaderDoorHeldMask($input: SetReaderDoorHeldMaskInput!) {
    setReaderDoorHeldMask(input: $input) {
      devices {
        deviceName
        status
      }
      message
      requestUUID
      status
    }
  }
`;
export const setReaderDoorForcedMask = /* GraphQL */ `
  mutation SetReaderDoorForcedMask($input: SetReaderDoorForcedMaskInput!) {
    setReaderDoorForcedMask(input: $input) {
      devices {
        deviceName
        status
      }
      message
      requestUUID
      status
    }
  }
`;
export const setPacsDataApiReaderMask = /* GraphQL */ `
  mutation SetPacsDataApiReaderMask($path: String!) {
    setPACSDataAPIReaderMask(path: $path) {
      status
    }
  }
`;
